
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"0 0 80 80"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#E3BFF8","d":"M40.096 24.507l14.166 9.416c.034-.565.167-1.098.167-1.697C54.429 19.95 44.485 10 32.214 10 19.944 10 10 19.949 10 32.227c0 12.277 9.943 22.226 22.214 22.226.233 0 .466-.067.699-.067v-26.02c0-3.692 4.123-5.922 7.183-3.859z"}}),_c('path',{attrs:{"fill":"#A127E8","fill-rule":"evenodd","d":"M32.912 28.367c0-3.694 4.09-5.923 7.183-3.86l14.164 9.448.003-.032 13.668 9.084c2.76 1.83 2.76 5.889 0 7.686L40.095 69.226c-3.06 2.03-7.183-.166-7.183-3.86V28.367z","clip-rule":"evenodd"}})])
          )
        }
      }
    